<template>
<!-- 
    冻结明细表格
 -->
    <div class="freeze_table_container">
        <div class="clearFix" v-loading="loading">
            <div class="search">
                <span class="date">封禁日期：</span>
                <!-- <pop content="默认查询今日以前所有的冻结金额明细"></pop> -->
                <el-date-picker
                    type="daterange"
                    start-placeholder="请选择"
                    end-placeholder="请选择"
                    v-model="time"
                >
                </el-date-picker>
                <el-button type="primary" @click="handleSearch">查询</el-button>
            </div>
            <el-table
                :data="freezeTableData"
                style="width: 100%; margin-bottom: 10px"
            >
                <el-table-column
                    v-for="item in freezeTableColumn"
                    :key="item.prop"
                    :prop="item.prop"
                    :label="item.label"
                >
                </el-table-column>
            </el-table>
            <div class="pag_container">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :page-size="10"
                    @current-change="tablePageChange"
                >
                </el-pagination>
            </div>
        </div>
        <div class="freeze_dialog_footer">
            <span>退款暂封金额不会被包含在账户余额中！</span>
            <el-button type="primary" @click="close">知道了</el-button>
        </div>
    </div>
</template>
<script>
import {requestDetailData} from '../../api/apiMap/index.js';
// import pop from '../../components/pop';
export default {
    // components: {
    //     pop
    // },
    props: ['appId', 'close'],
    data() {
        return {
            loading: false,
            freezeTableColumn: [
                {
                    prop: 'operateTime',
                    label: '禁封时间',
                },
                {
                    prop: 'orderId',
                    label: '订单号',
                },
                {
                    prop: 'thirdOrderId',
                    label: '业务方订单号',
                },
                {
                    prop: 'frozenReason',
                    label: '退款状态',
                },
                {
                    prop: 'money',
                    label: '封禁金额',
                }
            ],
            freezeTableData: [], // 冻结金额明细表格数据
            time: ['', new Date()],
            curPage: 1,
            total: 0,
            startTime: '',
            endTime: new Date().getTime() + ''
        }
    },
    created() {
        this.searchTableData();
    },
    methods: {
        searchTableData(clickSearch) {
            // 标记是否点击查询按钮, 如果是,要重置查询条件, 如果点击的是翻页不重置
            if (clickSearch) {
                this.startTime = (this.time && this.time[0]) ? (new Date(this.time[0]).getTime() + '') : '';
                this.endTime = (this.time && this.time[1]) ? (new Date(this.time[1]).getTime() + '') : '';
                if (!this.time || !this.time[1]) {
                    this.$message.error('您所选的参数有误!');
                    return;
                }
                this.curPage = 1;
                this.total = 0;
            }
            let params = {};
            params.appId = this.appId;
            params.moneyType = 20;
            params.timeType = 1;
            params.pageSize = 6;
            // 默认情况下, 就不传递开始时间了
            if (this.startTime) {
                params.startTime = this.startTime;
            }
            params.endTime = this.endTime;
            params.curPage = this.curPage;
            this.loading = true;
            requestDetailData(params).then(
                result => {
                    if (result.errno === 0) {
                        this.freezeTableData = result.data ? result.data.data : [];
                        this.total = result.data ? result.data.totalCount : 0;
                        this.loading = false;
                    } else {
                        this.$message.error(result.errmsg || result.msg || '');
                        this.loading = false;
                    }
                }
            ).catch(() => {
                this.$message.error('网络错误');
                this.loading = false;
            });
        },
        handleSearch() {
            this.searchTableData(true);
        },
        tablePageChange(page) {
            this.curPage = page;
            this.searchTableData();
        }
    }
};
</script>
<style lang="less" scope>
    .freeze_table_container {
        .search {
            margin-bottom: 15px;
            .el-date-editor--daterange,
            .el-button {
                transform: scale(80%);
                transform-origin: 0;
            }
        }
    }
</style>